import React from 'react';
import { Card, Badge } from 'react-bootstrap';

function CommentCard({ comment }) {
  // 日付フォーマット変換（YYYYMMDD_R → YYYY年MM月DD日 R)
  const formatRaceDate = (date_race) => {
    if (!date_race) return '日付不明';
    
    const parts = date_race.split('_');
    if (parts.length !== 2) return date_race;
    
    const dateStr = parts[0];
    const raceNum = parts[1];
    
    if (dateStr.length !== 8) return date_race;
    
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    const day = dateStr.substring(6, 8);
    
    return `${year}年${month}月${day}日 ${raceNum}R`;
  };

  // 自信度（ピースター）のバッジ色を決定する
  const getRateBadgeVariant = (rate) => {
    switch(parseInt(rate)) {
      case 5: return 'warning';  // 金色に近い
      // case 4: return 'primary';
      // case 3: return 'info';
      // case 2: return 'secondary';
      // case 1: return 'light';
      default: return 'dark';
    }
  };

  // 枠番号に応じたバッジの色を決定する
  const getFrameBadgeVariant = (frame) => {
    switch(parseInt(frame)) {
      case 1: return 'light'; // 白色
      case 2: return 'dark'; // 黒色
      case 3: return 'danger'; // 赤色
      case 4: return 'primary'; // 青色
      case 5: return 'warning'; // 黄色
      case 6: return 'success'; // 緑色
      default: return 'info'; // デフォルト
    }
  };

  // 自信度を星マークで表示
  const renderRateStars = (rate) => {
    const stars = [];
    const starCount = parseInt(rate) || 0;
    
    for (let i = 0; i < starCount; i++) {
      stars.push(<span key={i}>★</span>);
    }
    
    return (
      <Badge 
        bg={getRateBadgeVariant(rate)}
        className="rate-badge"
      >
        {stars.length > 0 ? stars : '0'}
      </Badge>
    );
  };

  // 着順の表示用スタイルを設定
  const getResultStyle = (result) => {
    if (!result) return { variant: 'light', text: '不明' };
    
    const resultNum = parseInt(result);
    if (resultNum === 1) return { variant: 'warning', text: '1着' };
    // if (resultNum === 2) return { variant: 'success', text: '2着' };
    // if (resultNum === 3) return { variant: 'primary', text: '3着' };
    return { variant: 'secondary', text: `${resultNum}着` };
  };

  const resultStyle = getResultStyle(comment.result);

  // 枠番号が1（白色）の場合は文字色を黒に設定
  const getFrameBadgeTextClass = (frame) => {
    return parseInt(frame) === 1 ? 'text-dark' : '';
  };

  return (
    <Card className="h-100 comment-card">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <span>{formatRaceDate(comment.participation_race)}</span>
        {comment.result && (
          <Badge bg={resultStyle.variant} className="result-badge">
            {resultStyle.text}
          </Badge>
        )}
      </Card.Header>
      <Card.Body>
        <div className="mb-2 d-flex justify-content-between align-items-center">
          {comment.frame && (
            <Badge 
              bg={getFrameBadgeVariant(comment.frame)} 
              className={`frame-badge ${getFrameBadgeTextClass(comment.frame)}`}
            >
              {comment.frame}枠
            </Badge>
          )}
          {comment.rate && (
            <div className="rate-stars">{renderRateStars(comment.rate)}</div>
          )}
        </div>
        <Card.Text className="comment-text">
          {comment.comment || 'コメントなし'}
        </Card.Text>
      </Card.Body>
      <Card.Footer className="text-muted">
        <small>{comment.race_title || 'レース情報なし'}</small>
      </Card.Footer>
    </Card>
  );
}

export default CommentCard;